import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'
import LoadingSpinner from '../../../common/LoadingSpinner'

const ViewMoreButton = ({ handleClick, isFetchingNextPage }) => {
  const { t } = useTranslation()
  console.log(isFetchingNextPage, 'isFetchingNextPage')
  return (
    <div>
      <DSButton
        size={BUTTON_SIZE.SM}
        type={BUTTON_TYPE.OUTLINE}
        onClick={handleClick}
        customBorderColor={COLORS.PURPLE500}
        customBgColor={COLORS.WHITE}
        className="mt-[4px]"
      >
        <DSButton.Label customTxtColor={COLORS.PURPLE500}>
          {isFetchingNextPage ? <LoadingSpinner primary show md /> : t(n_caf.complexity.viewmore_btn)}
        </DSButton.Label>
      </DSButton>
    </div>
  )
}

export default ViewMoreButton
